import { render, staticRenderFns } from "./XildaMaster.vue?vue&type=template&id=2059ee70&"
import script from "./XildaMaster.vue?vue&type=script&lang=js&"
export * from "./XildaMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports